
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/HeaderDropdown/index.less?modules";
export default {"container": `container-b_RknHFi`}
